<template>
    <v-container fluid>
        <v-data-table
            :headers="headers"
            :items="users"
            :page.sync="pagination.current"
            :items-per-page="pagination.itemsPerPage"
            disable-pagination
            :hide-default-footer="true"
            sort-by="id"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>系統使用者資訊</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <!--資料編輯對話框-->
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">建立使用者</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-form ref="form" lazy-validation>
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                    v-model="editedItem.user_name"
                                                    label="使用者名稱"
                                                    :rules="[(v) => !!v || '請填寫使用者名稱']"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                    v-model.trim="editedItem.user_account"
                                                    :rules="[(v) => !!v || '請填寫電子郵件帳號']"
                                                    label="登入帳號"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <template v-if="formTitle === '新增使用者'">
                                                    <v-text-field
                                                        v-model.trim="editedItem.password"
                                                        required
                                                        label="登入密碼"
                                                        :rules="createPasswordRules"
                                                    ></v-text-field>
                                                </template>
                                                <template v-else>
                                                    <v-text-field
                                                        v-model.trim="editedItem.password"
                                                        label="登入密碼"
                                                    ></v-text-field>
                                                </template>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <!--角色，如果是助理、業務員，需要選擇對應的業務員；助理可多選、業務員可單選-->
                                            <v-col>
                                                <v-select
                                                    :items="roles"
                                                    v-model="editedItem.role"
                                                    item-text="displayname"
                                                    item-value="role"
                                                    label="登入角色"
                                                    :rules="[(v) => !!v || '請選擇登入角色']"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer>{{dialogMessage}}</v-spacer>
                                <v-btn :loading="loading" color="blue darken-1" text @click="close">取消</v-btn>
                                <v-btn :loading="loading" color="blue darken-1" text @click="save">儲存</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="headline">您確定要刪除此資料？</v-card-title>
                            <v-card-text>{{deleteDialogMessage}}</v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDelete">取消</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">刪除</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <!-- 資料表格 -->
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon large class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon large @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="searchRecord">載入資料</v-btn>
            </template>
        </v-data-table>
        <v-pagination v-model="pagination.current" :length="pagination.total" @input="onPageChange"></v-pagination>
    </v-container>
</template>
<script>
import UserService from '../../services/UserService'

export default {
    name: "user",
    data(){
        return{
            headers:[
                {text: '使用者名稱', value:'user_name', width: '120px'},
                {text: '登入帳號', value:'user_account', sortable:false, width:'200px'},
                {text: '角色', value:'role', sortable:false},
                {text: 'Action', value:'actions', sortable:false, width: '180px'}
            ],
            roles:[
                {role: 'manager', displayname:'經理'},
                {role: 'assistant', displayname:'助理'},
                {role: 'sales', displayname:'業務員'},
            ],
            users:[],
            dialog:false,
            dialogDelete:false,
            publish_date_menu:false,
            editedItem: { id:-1, user_name: '', user_account: '', password: '', role: '', salesmans:[]},
            editedIndex: -1,
            defaultItem:{ id:-1, user_name: '', user_account: '', password: '', role: '', salesmans:[]},
            pagination: {
                current: 1,
                total: 0,
                itemsPerPage: 20
            },
            dialogMessage: '',
            deleteDialogMessage: '',
            loading: false,
            createPasswordRules:[
                v => !! v || '密碼必須輸入',
                v => (v && v.length >= 6) || '密碼長度請輸入六個以上字元'
            ]
        }
    },
    computed:{
        formTitle(){
            return this.editedIndex === -1 ? '新增使用者' : '編輯使用者'
        },
        
    },
    created(){
        this.searchRecord()
    },
    methods:{
        close(){
            this.dialog = false
            this.$nextTick(()=>{
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        save(){
            if (this.$refs.form.validate()){
                this.loading = true;
                if (this.editedIndex > -1){
                    //修改使用者資料
                    UserService.updateUser(this.editedItem).then((response)=>{
                        if (response.result === true){
                            Object.assign(this.users[this.editedIndex], this.editedItem);
                            this.dialogMessage='';
                            this.loading = false;
                            this.close();
                        } else {
                            this.dialogMessage = response.message;
                        }
                    })
                    .catch((e) => {
                        this.loading = false;
                        console.log(e);
                    })
                } else {
                    //建立使用者資料
                    UserService.createUser(this.editedItem).then((response)=>{
                        if (response.result === true){
                            this.editedItem.id = response.item.id;
                            this.users.push(this.editedItem);
                            this.dialogMessage='';
                            this.loading= false;
                            this.close();
                        } else {
                            this.dialogMessage = response.message;
                            this.loading = false;
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
                }
            }
        },
        closeDelete(){
            this.dialogDelete = false
            this.$nextTick(()=>{
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        deleteItemConfirm(){
            //確認進行刪除
            UserService.deleteUser(this.editedItem.id).then((response) =>{
                if (response.result === true){
                    this.users.splice(this.editedIndex, 1);
                    this.deleteDialogMessage='';
                    this.closeDelete();
                } else {
                    this.deleteDialogMessage = response.message;
                }
            })
            .catch((e) => {
                console.log(e);
            })
        },
        editItem(item){
            //編輯項目
            this.editedIndex = this.users.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        deleteItem(item){
            //開啟刪除確認對話框
            this.editedIndex = this.users.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        searchRecord(){
            UserService.findByCondition(this.pagination_current, this.pagination.itemsPerPage).then((response)=>{
                if (response.result === true){
                    this.users = response.list.map(this.mapData);
                    this.pagination.total = response.last_page;
                } else {
                    this.users = [];
                }
            })
            .catch((e)=> {
                console.log(e);
            })
        },
        mapData(item){
            return{
                id: item.id,
                user_name: item.name,
                user_account: item.email,
                role: item.role,
                salesmans: item.salesmans
            }
        },
        onPageChange(){
            this.searchRecord();
        }
    },
    watch:{
        dialog(val){
            val || this.close()
        },
        dialogDelete(val){
            val || this.closeDelete()
        },
    }
}
</script>
